import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandlerService } from '../../services';
import { DashboardService } from '../../dashboard';
var CourseAdminComponent = /** @class */ (function () {
    function CourseAdminComponent(dashboardService, router, route, errorHandlerService) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.errorHandlerService = errorHandlerService;
        this.courselist = [];
        this.approveClick = false;
        this.rejectClick = false;
        this.temp_id = "";
        this.searchdata = {};
        this.approve_data = { approvaltype: "0" };
        this.abtnText = "Approve";
        this.rbtnText = "Reject";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.subscriptions = [];
    }
    CourseAdminComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CourseAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.dashboardService.courseadmin().subscribe(function (data) { console.log(data); _this.courselist = data; }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    CourseAdminComponent.prototype.courseSearch = function () {
        var _this = this;
        var s2 = this.dashboardService.courseadminsearch(this.searchdata).subscribe(function (data) { console.log(data); _this.courselist = data; }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    CourseAdminComponent.prototype.approvePop = function (id) {
        this.temp_id = id;
        this.approveClick = true;
    };
    CourseAdminComponent.prototype.rejectPop = function (id) {
        this.temp_id = id;
        this.rejectClick = true;
    };
    CourseAdminComponent.prototype.courseApprove = function () {
        var _this = this;
        if (this.temp_id != "") {
            this.abtnText = "Please Wait...";
            this.approve_data.courseId = this.temp_id.toString();
            this.approve_data.command = "approve";
            var s3 = this.dashboardService.courseadminapprove(this.approve_data).subscribe(function (data) {
                console.log(data);
                _this.abtnText = "Approve";
                _this.dashboardService.courseadmin().subscribe(function (data) {
                    console.log(data);
                    if (data.success) {
                        _this.courselist = data;
                        _this.approveClick = false;
                        _this.abtnText = "Approve";
                    }
                    else {
                        _this.approveClick = false;
                        console.log("data.errorMsg-->>" + data.errorMsg);
                        _this.createInfoAlert(data.errorMsg);
                    }
                }, function (error) { console.log(error); _this.abtnText = "Approve"; });
            }, function (error) {
                _this.handleError(error);
                _this.abtnText = "Approve";
            });
            this.subscriptions.push(s3);
        }
    };
    CourseAdminComponent.prototype.courseReject = function () {
        var _this = this;
        if (this.temp_id != "") {
            this.rbtnText = "Please Wait...";
            var reject_data = {};
            reject_data.courseId = this.temp_id.toString();
            reject_data.command = "reject";
            var s5 = this.dashboardService.courseadminreject(reject_data).subscribe(function (data) {
                console.log(data);
                _this.rbtnText = "Reject";
                _this.dashboardService.courseadmin().subscribe(function (data) { console.log(data); _this.courselist = data; _this.rejectClick = false; _this.rbtnText = "Reject"; }, function (error) {
                    if (error.Uvsity_Errors) {
                        _this.msgTitle = "Error";
                        _this.msgContent = error.Uvsity_Errors;
                        _this.popUp = true;
                    }
                    _this.abtnText = "Reject";
                });
            }, function (error) {
                _this.handleError(error);
                _this.abtnText = "Reject";
            });
            this.subscriptions.push(s5);
        }
    };
    CourseAdminComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    CourseAdminComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    CourseAdminComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return CourseAdminComponent;
}());
export { CourseAdminComponent };
//# sourceMappingURL=courseAdmin.component.js.map